export const API_BASE =
  process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:5001/lubecks-taxi/us-central1/api"
    : "https://api-rwljeucb4a-uc.a.run.app";
